export const SOURCE_VIDEOS_KEY_PREFIX = 'source';
export const PROCESSED_VIDEOS_KEY_PREFIX = 'processed';
